import Api from './api'

export default {
    search(code, placeId, clientId, useDescription) {
        let now = new Date();
        now.setDate(now.getDate() - 1);
        let from = now.getFullYear() + '-' + ("0" + (now.getMonth() + 1)).slice(-2) + '-' + ("0" + now.getDate()).slice(-2)
        let data = {
            place_id: placeId,
            client_id: clientId,
            use_description: useDescription,
            search: code,
            from: from
        }
        return Api.post('live/order/lightsearch', data).then(response => {
            if (response.data.ok) {
                return response.data.response
            } else {
                return false
            }
        });
    }
};